import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from '@references/shared/guards/authenticated.guard';
import { EnvironmentsService } from '@references/shared/services/environments.service';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { MfaGuard } from '@shared/guards/mfa.guard';
import { CountriesService } from '@shared/services/countries.service';
import { UsersService } from '@shared/services/users.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';

export const routes: Routes = [
  {
    path: 'embed',
    loadChildren: () =>
      import('@references/embed/embed.module').then((m) => m.EmbedModule)
  },
  {
    // The MFA challenge must be reachable by a password-only (mfa_pending)
    // session, which has no roles and is refused by the API on everything but
    // the MFA endpoints: keep it clear of the AuthenticatedGuard and the
    // resolvers that front the protected shell below (VIT-1346).
    path: 'mfa',
    canActivate: [MfaGuard],
    loadChildren: () =>
      import('@shared/routing/mfa/mfa.module').then((m) => m.MFAModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('@references/protected/protected.module').then(
        (m) => m.ProtectedModule
      ),
    canActivate: [AuthenticatedGuard],
    resolve: {
      user: UsersService,
      countries: CountriesService
    }
  },
  {
    path: '',
    loadChildren: () =>
      import('@references/public/public.module').then((m) => m.PublicModule),
    resolve: {
      countries: CountriesService,
      environment: EnvironmentsService
    }
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false,
      preloadingStrategy: CustomPreloadingStrategy
    })
  ],
  exports: [RouterModule]
})
export class CoreRoutingModule {}
